import api from '../api';
var SearchApi = /** @class */ (function () {
    function SearchApi() {
    }
    SearchApi.search = function (searchText) {
        var uri = "api/search?q=" + encodeURIComponent(searchText);
        return api.get(uri).then(function (i) { return i.data; });
    };
    return SearchApi;
}());
export default SearchApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/SearchApi.ts
// module id = 811
// module chunks = 0